// extracted by mini-css-extract-plugin
module.exports = {"container":"Pin_container__tsoxV","header":"Pin_header__2vpwI","pin-info":"Pin_pin-info__JUC8Y","tick-icon":"Pin_tick-icon__2Z2R0","btn":"Pin_btn__3gXiu"};